module.exports = __webpack_public_path__ + "img/euro_Energy.a09926f0.png";